module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "back-to-top-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vue-back-to-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._t("default", function() {
    return [_c('div', {
      staticClass: "default"
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_upward")]), _vm._v(" "), _c('span', [_vm._v("\n          Back To Top\n        ")])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ec0544","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackToTop.vue
// module id = 204
// module chunks = 1